import script from "./CRMWhatsappContactFollowupsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CRMWhatsappContactFollowupsView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__